import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { IS_MOBILE, __EventDispatcher } from "../../../_core/core";
import { EventClass, EventType } from "../../config/Events";

import DrawTimer from "./Draw.timer";
import DrawHistory from "./Draw.history";

//import Icons & Assets
import Logo from "../../../assets/imgs/keno-logo.svg";
import { TicketIcon } from "../icons/Ticket";

const DrawInfo = (_props?: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isMobile, setIsMobile] = useState<boolean>(IS_MOBILE);

  const onEventDispatched = (
    _eventClass: EventClass,
    _eventType: any,
    _eventPayload?: any
  ) => {
    if (_eventClass === EventClass.SYSTEM) {
      switch (_eventType) {
        case EventType.SYSTEM.CANVAS_RESIZED:
          setIsMobile(_eventPayload.bResolution !== "DESKTOP" || IS_MOBILE);
          break;
      }
    }
  };

  useEffect(() => {
    __EventDispatcher.addListener(EventClass.SYSTEM, onEventDispatched, this);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="game-board-statuses">
      <div className="logo-wrapper">
        <img
          src={Logo}
          alt="Keno"
          className="logo-keno game-board-status-heading"
        />
      </div>
      <DrawHistory />
      <DrawTimer
        duration={_props.GAMEPLAY.timer}
        drawNumber={_props.GAMEPLAY.drawNumber}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    GAMEPLAY: state.game.GAMEPLAY,
    STATUS_DATA: state.game.STATUS_DATA,
    failedBets: state.game.GAMEPLAY.failedBets,
  };
};

export default connect(mapStateToProps, {})(DrawInfo);
